/** @module polyfills */

/**
 * Ensures support for modern <picture/> element.
 */
export function picturefill() {
    // use pseudo-dynamic import to make package free from side-effects
    import(/* webpackMode: "eager" */ 'picturefill');
}
